import { makeStyles } from '@material-ui/core/styles';

import { SLATE_TEXT_FORMATS } from 'src/lib/slate';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      flexFlow: 'column nowrap',

      '&$singleLine': {
        overflow: 'hidden',

        // render editor content in one line
        '& $editable': {
          display: 'flex',
          flexFlow: 'row nowrap',
          whiteSpace: 'nowrap !important',
          overflowWrap: 'unset !important',

          // we need to accommodate increased paddings around "instruction" nodes
          lineHeight: theme.typography.pxToRem(20),

          // update some "instruction" node styles, so they look better in one-line mode
          [`& [data-node-type="${SLATE_TEXT_FORMATS.PROMPT_INSTRUCTION}"]`]: {
            padding: theme.spacing(0, 1),
            margin: 0,
          },
        },
      },
    },
    singleLine: {},

    editable: {
      fontSize: theme.typography.regular12.fontSize,
    },
  }),
  { name: 'ReadonlyStructure' }
);
